import { date } from 'common';
import Button from '../../st-button/st-button';
import { requireAttendanceGridContext } from '../st-attendance-grid';
import styles from '../st-attendance-grid.module.css';

export function WeekNavPrev() {
    const ctx = requireAttendanceGridContext();

    return (
        <Button label="Previous" icon="fa fa-chevron-left" onClick={() => ctx.setDay(date.addDays(ctx.day(), -7))} enabled={!ctx.isLoading[0]()} />
    );
}

export function WeekNavNext() {
    const ctx = requireAttendanceGridContext();

    return (
        <Button label="Next" icon="fa fa-chevron-right" onClick={() => ctx.setDay(date.addDays(ctx.day(), 7))} enabled={!ctx.isLoading[0]()} />
    );
}

